import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, CalendarDays, Layers, Search, ArchiveRestore, Sparkles } from 'lucide-react';

const TomoHero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-amber-50 via-orange-50 to-rose-50 pt-20 pb-16">
      <div className="absolute -top-24 -right-24 w-[28rem] h-[28rem] rounded-full bg-orange-300 opacity-20 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 w-[28rem] h-[28rem] rounded-full bg-rose-300 opacity-20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-orange-100 text-orange-800 text-sm font-medium mb-6">
            <Sparkles className="w-4 h-4 mr-2" /> Smart Task Management
          </div>

          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Organize Your Life
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-orange-600 via-pink-600 to-rose-600">
              With Tomo
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 mb-10 max-w-3xl mx-auto leading-relaxed">
            Create tasks smarter, filter faster, and stay on top of what matters. Tomo makes planning effortless
            with intelligent categories, real-time search, and an elegant archive system.
          </p>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {[{icon: CheckCircle2, t: 'Smart Creation', d: 'Title, description, category, priority, due date'},
              {icon: Layers, t: 'Dynamic Categories', d: 'Auto-extracted categories for quick filtering'},
              {icon: Search, t: 'Instant Search', d: 'Real-time search across all task content'},
              {icon: CalendarDays, t: 'Due Dates', d: 'Plan ahead with clear schedules'},
              {icon: ArchiveRestore, t: 'History Archive', d: 'Auto-archive with restore/delete'},
              {icon: Sparkles, t: 'Clean UI', d: 'Minimal and focused experience'}].map((f, i) => (
              <div key={i} className="bg-white rounded-2xl p-5 shadow-sm border border-orange-100 text-left">
                <f.icon className="w-6 h-6 text-orange-600 mb-3" />
                <div className="font-semibold text-gray-900">{f.t}</div>
                <div className="text-sm text-gray-600 mt-1">{f.d}</div>
              </div>
            ))}
          </div>

          <div className="mt-10">
            <a
              href="https://play.google.com/store/apps/details?id=com.obrez.daily.dolist"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-8 py-4 rounded-xl bg-gradient-to-r from-orange-600 to-rose-600 text-white font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              View on Google Play
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TomoHero; 